// Vision
export const CREATE_VISION_REQUEST = 'CREATE_VISION_REQUEST';
export const CREATE_VISION_SUCCESS = 'CREATE_VISION_SUCCESS';
export const CREATE_VISION_FAIL = 'CREATE_VISION_FAIL';

export const GET_VISIONS_REQUEST = 'GET_VISIONS_REQUEST';
export const GET_VISIONS_SUCCESS = 'GET_VISIONS_SUCCESS';
export const GET_VISIONS_FAIL = 'GET_VISIONS_FAIL';

export const GET_VISION_REQUEST = 'GET_VISION_REQUEST';
export const GET_VISION_SUCCESS = 'GET_VISION_SUCCESS';
export const GET_VISION_FAIL = 'GET_VISION_FAIL';

export const UPDATE_VISION_REQUEST = 'UPDATE_VISION_REQUEST';
export const UPDATE_VISION_SUCCESS = 'UPDATE_VISION_SUCCESS';
export const UPDATE_VISION_FAIL = 'UPDATE_VISION_FAIL';

export const DELETE_VISION_REQUEST = 'DELETE_VISION_REQUEST';
export const DELETE_VISION_SUCCESS = 'DELETE_VISION_SUCCESS';
export const DELETE_VISION_FAIL = 'DELETE_VISION_FAIL';

// Nodes
export const CREATE_NODE_REQUEST = 'CREATE_NODE_REQUEST';
export const CREATE_NODE_SUCCESS = 'CREATE_NODE_SUCCESS';
export const CREATE_NODE_FAIL = 'CREATE_NODE_FAIL';

export const UPDATE_NODE_REQUEST = 'UPDATE_NODE_REQUEST';
export const UPDATE_NODE_SUCCESS = 'UPDATE_NODE_SUCCESS';
export const UPDATE_NODE_FAIL = 'UPDATE_NODE_FAIL';

export const DELETE_NODE_REQUEST = 'DELETE_NODE_REQUEST';
export const DELETE_NODE_SUCCESS = 'DELETE_NODE_SUCCESS';
export const DELETE_NODE_FAIL = 'DELETE_NODE_FAIL';

// Connections
export const CREATE_CONNECTION_REQUEST = 'CREATE_CONNECTION_REQUEST';
export const CREATE_CONNECTION_SUCCESS = 'CREATE_CONNECTION_SUCCESS';
export const CREATE_CONNECTION_FAIL = 'CREATE_CONNECTION_FAIL';

export const DELETE_CONNECTION_REQUEST = 'DELETE_CONNECTION_REQUEST';
export const DELETE_CONNECTION_SUCCESS = 'DELETE_CONNECTION_SUCCESS';
export const DELETE_CONNECTION_FAIL = 'DELETE_CONNECTION_FAIL';

// Chat
export const PLANNING_CHAT_REQUEST = 'PLANNING_CHAT_REQUEST';
export const PLANNING_CHAT_SUCCESS = 'PLANNING_CHAT_SUCCESS';
export const PLANNING_CHAT_FAIL = 'PLANNING_CHAT_FAIL';

export const ONBOARD_REQUEST = 'ONBOARD_REQUEST';
export const ONBOARD_SUCCESS = 'ONBOARD_SUCCESS';
export const ONBOARD_FAIL = 'ONBOARD_FAIL';

export const SUGGEST_NODES_REQUEST = 'SUGGEST_NODES_REQUEST';
export const SUGGEST_NODES_SUCCESS = 'SUGGEST_NODES_SUCCESS';
export const SUGGEST_NODES_FAIL = 'SUGGEST_NODES_FAIL';

export const PLANNING_CLEAR_ERRORS = 'PLANNING_CLEAR_ERRORS';

// Node type config (for UI)
export const NODE_TYPES = {
  milestone: { label: 'Milestone', color: '#10b981', description: 'Major checkpoints and outcomes' },
  action: { label: 'Action', color: '#3b82f6', description: 'Specific things to do' },
  obstacle: { label: 'Obstacle', color: '#ef4444', description: 'Blockers and challenges' },
  doubt: { label: 'Doubt', color: '#f59e0b', description: 'Uncertainties and fears' },
  belief: { label: 'Belief', color: '#8b5cf6', description: 'Assumptions and principles' },
  decision: { label: 'Decision', color: '#06b6d4', description: 'Key choices made or to be made' },
  update: { label: 'Update', color: '#64748b', description: 'Progress notes' },
  note: { label: 'Note', color: '#94a3b8', description: 'Free-form thoughts' },
};

export const CONNECTION_TYPES = {
  addresses: { label: 'addresses', description: 'This node speaks to / handles another' },
  blocks: { label: 'blocks', description: 'This is blocking another' },
  requires: { label: 'requires', description: 'Depends on another being done first' },
  justifies: { label: 'justifies', description: 'Provides reason or evidence' },
  contradicts: { label: 'contradicts', description: 'Is in tension with another' },
  resolves: { label: 'resolves', description: 'Resolves a doubt or obstacle' },
  depends_on: { label: 'depends on', description: 'Weaker dependency' },
  related_to: { label: 'related to', description: 'Generic connection' },
};
